import { Typeahead as PlainTypeahead } from "./typeahead";
import { WithAsync } from "./with-async";
import { WithLabel } from "../components/with-label";

export const Typeahead = WithLabel(PlainTypeahead);
export const AsyncTypeahead = WithAsync(Typeahead);
